import React, { useState, useMemo, useEffect, useRef, ReactNode } from 'react';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import { Config } from '@/config';
import {
  errorModalTextRecoil,
  completeModalRecoil,
  modifyModalRecoil,
  modelReportModalRecoil,
} from '@/atom/ModalAtom';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import LS from '@/styles/layoutStyled';
import CS from '@/styles/componentStyled';
import BS from '@/styles/btnStyled';
import IS from '@/styles/inputStyled';
import ModalType1 from '@/modal/ModalType1';
import { ModelApi } from '@/sdk/ModelApi';
import { UpdateModelReportTx2 } from '@/sdk/data-contracts';
import { modelReportRecoil } from '@/atom/ModelAtom';

interface ModelReportModalProps {
  id: number;
}

const ModelReportModal = ({ id }: ModelReportModalProps) => {
  const modelApi = new ModelApi({ baseURL: Config.API_URL });
  const navigate = useNavigate();

  const setErrorModalText = useSetRecoilState(errorModalTextRecoil);
  const setCompleteModalState = useSetRecoilState(completeModalRecoil);
  const setmodelReportModalState = useSetRecoilState(modelReportModalRecoil);
  const [modelReportState, setModelReportState] =
    useRecoilState(modelReportRecoil);

  const fetchModelReport = async () => {
    try {
      const { data } = await modelApi.modelControllerGetReports(id, {
        headers: {
          Authorization: `Bearer ${String(sessionStorage.getItem('accessToken'))}`,
          'Content-Type': 'application/json',
        },
      });
      setModelReportState(data);
    } catch (err: any) {}
  };

  const handleCheckboxChange = (index: number) => {
    setModelReportState((prevState) =>
      prevState.map((item, i) =>
        i === index ? { ...item, isView: !item.isView } : item,
      ),
    );
  };

  const handleSelectChange = (index: number, value: string) => {
    setModelReportState((prevState) =>
      prevState.map((item, i) =>
        i === index ? { ...item, unit: value } : item,
      ),
    );
  };

  const handleSubmit = async () => {
    const dto: UpdateModelReportTx2[] = modelReportState;
    try {
      await modelApi.modelControllerUpdateReport(id, dto, {
        headers: {
          Authorization: `Bearer ${String(sessionStorage.getItem('accessToken'))}`,
          'Content-Type': 'application/json',
        },
      });
      setCompleteModalState(true);
    } catch (err: any) {}
  };

  useEffect(() => {
    fetchModelReport();
  }, []);

  return (
    <>
      <ModalType1 width={1200}>
        <div className="title-box flex aic jcsb">
          <h1>리포트 데이터 관리</h1>
          <button
            className="x-btn img-box"
            onClick={() => setmodelReportModalState(false)}
          >
            <img src="/img/ico_x_444.svg" alt="" />
          </button>
        </div>
        <div className="cnt-area flex fdc">
          <div className="cnt-wrap flex fdc">
            <div className="cnt-box flex fdc">
              <div className="cnt-title-box flex jcsb aie">
                <div className="left-box">
                  <h2 className="tm">리포트 생성 필드 항목</h2>
                </div>
              </div>
              <InforWrap>
                {modelReportState.map((list, index) => (
                  <InforBox key={list.id}>
                    <CS.Gap8Box>
                      <IS.CheckBoxType1>
                        <input
                          type="checkbox"
                          id={`rv-${index}`}
                          checked={list.isView}
                          onChange={() => handleCheckboxChange(index)}
                        />
                        <label htmlFor={`rv-${index}`} className="img-box">
                          <img src="/img/ico_check_1.svg" alt="" />
                        </label>
                      </IS.CheckBoxType1>
                      <h1>데이터 {index + 1}</h1>
                    </CS.Gap8Box>
                    <div className="text-wrap">
                      <ul className="text-box">
                        <li>
                          <h2 style={{ minWidth: 118 }}>데이터 명</h2>
                          <p>{list.dataName}</p>
                        </li>
                        <li>
                          <h2 style={{ minWidth: 118 }}>표시 구분</h2>
                          <p>{list.displayClassification}</p>
                        </li>
                        <li>
                          <h2 style={{ minWidth: 118 }}>데이터 최소값</h2>
                          <p>{list.minData}</p>
                        </li>
                        <li>
                          <h2 style={{ minWidth: 118 }}>소수점</h2>
                          <p>{list.point}</p>
                        </li>
                      </ul>
                      <ul className="text-box">
                        <li>
                          <h2 style={{ minWidth: 118 }}>데이터 타입</h2>
                          <p>{list.dataType}</p>
                        </li>
                        <li>
                          <h2 style={{ minWidth: 118 }}>구간 수</h2>
                          <p>{list.sectionsNumber}</p>
                        </li>
                        <li>
                          <h2 style={{ minWidth: 118 }}>데이터 최대값</h2>
                          <p>{list.maxData}</p>
                        </li>
                        <li>
                          <h2 style={{ minWidth: 118 }}>리포트 유닛</h2>
                          <IS.SelectType1 style={{ width: 110 }}>
                            <select
                              value={list.unit}
                              onChange={(e) =>
                                handleSelectChange(index, e.target.value)
                              }
                              className="selected"
                            >
                              <option value="현재값">현재값</option>
                              <option value="최대/최소">최대/최소</option>
                              <option value="변위">변위</option>
                            </select>
                            <span className="img-box">
                              <img src="/img/arrow_bottom_555.svg" alt="" />
                            </span>
                          </IS.SelectType1>
                        </li>
                      </ul>
                    </div>
                  </InforBox>
                ))}
              </InforWrap>
            </div>
          </div>
          <div className="btn-wrap">
            <BS.Btn2Type3
              type="button"
              onClick={() => setmodelReportModalState(false)}
            >
              취소
            </BS.Btn2Type3>
            <BS.Btn2Type4 type="button" onClick={handleSubmit}>
              수정
            </BS.Btn2Type4>
          </div>
        </div>
      </ModalType1>
    </>
  );
};

export default ModelReportModal;

export const InforWrap = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
`;

export const InforBox = styled(CS.CntBoxType2)`
  width: calc(50% - 10px);
  .text-wrap {
    .text-box {
      li {
        align-items: center;
      }
    }
  }
`;
